export * from './defaultTranslations';
export * from '../constants-generated';

export const IDENTITY_CLIENT_ID = 'SPADev';

// Bubble settings
export const bubbleDuration = 2000;
export const bubbleHeight = 94;
